export const mapUserToFormValues = (user, options) => {
  if (!user) return null;

  const findOptionId = (list, val, key = 'name') => {
    if (!list || !val) return '';
    const valStr = String(val).toLowerCase();
    return list.find(i => 
      i[key]?.toLowerCase().includes(valStr) ||
      valStr.includes(i[key]?.toLowerCase())
    )?._id || '';
  };

  // Basic info
  const baseValues = {
    fullName: user.full_name || '',
    dob: user.dob?.split('T')[0] || '',
    gender: user.gender || '',
    religion: findOptionId(options.religions, user.religion),
    occupation: findOptionId(options.occupations, user.occupation, 'title'),
    annualIncome: user.annual_income || '',
    caste: findOptionId(options.castes, user.caste),
    motherTongue: findOptionId(options.motherTongues, user.mother_tongue),
    zodiacSign: findOptionId(options.zodiac, user.zodiacSign),
    star: findOptionId(options.stars, user.star),
    maritalStatus: user.marital_status === 'Unmarried' ? 'Single' : user.marital_status || '',
    country: findOptionId(options.countries, user.country),
    state: findOptionId(options.states, user.state),
    city: findOptionId(options.cities, user.city),
    address: user.address || '',
    description: user.about_me || '',
    startupName: user.startup_name || '',
    industry: user.industry || '',
    linkedinProfile: user.linkedin_profile || '',
    companyName: user.company_name || '',
    expectedRevenue: user.expected_revenue || '',
    founderVision: user.founder_vision || '',
    hobbies: user.hobbies || '',
    fatherName: user.father_name || '',
    motherName: user.mother_name || '',
    siblings: user.siblings || '',
    familyStatus: user.family_status || '',
    familyType: user.family_type || '',
    familyValues: user.family_values || '',
    weight: user.weight || '',
    phoneNumber: user.phone_number || '',
    education: user.education || ''
  };

  // Handle entrepreneur fields
  if (user.is_entrepreneur) {
    const entrepreneurOccupation = options.occupations.find(o => 
      o.title?.toLowerCase().includes('entrepreneur')
    );
    if (entrepreneurOccupation) {
      baseValues.occupation = entrepreneurOccupation._id;
    }
  }

  return baseValues;
};

export const shouldShowEntrepreneurFields = (occupationId, occupations) => {
  if (!occupationId || !occupations) return false;
  const selected = occupations.find(o => o._id === occupationId);
  return selected?.title?.toLowerCase().includes('entrepreneur');
};

export const prepareSubmitData = (formValues, images, isPublic, occupations) => {
  const payload = {
    full_name: formValues.fullName.trim(),
    dob: formValues.dob,
    gender: formValues.gender,
    religion: formValues.religion,
    occupation: formValues.occupation,
    annual_income: formValues.annualIncome,
    caste: formValues.caste,
    mother_tongue: formValues.motherTongue,
    zodiac_sign: formValues.zodiacSign,
    star: formValues.star,
    marital_status: formValues.maritalStatus,
    country: formValues.country,
    state: formValues.state,
    city: formValues.city,
    address: formValues.address.trim(),
    about_me: formValues.description.trim(),
    images,
    visibility: isPublic ? 'Public' : 'Private',
    hobbies: formValues.hobbies,
    father_name: formValues.fatherName,
    mother_name: formValues.motherName,
    siblings: formValues.siblings,
    family_status: formValues.familyStatus,
    family_type: formValues.familyType,
    family_values: formValues.familyValues,
    weight: formValues.weight,
    phone_number: formValues.phoneNumber,
    education: formValues.education
  };

  // Add entrepreneur fields if applicable
  if (shouldShowEntrepreneurFields(formValues.occupation, occupations)) {
    payload.company_name = formValues.companyName?.trim() || '';
    payload.expected_revenue = formValues.expectedRevenue || '';
    payload.founder_vision = formValues.founderVision?.trim() || '';
    payload.startup_name = formValues.startupName?.trim() || '';
    payload.industry = formValues.industry?.trim() || '';
    payload.linkedin_profile = formValues.linkedinProfile?.trim() || '';
  }

  return payload;
};